<template>

  <div :id="_uid" class="ui fullscreen modal" :class="modalSelector">

    <div class="ui header">
      Laudos do Colaborador
    </div>

    <div class="modal-content-scrolling content">

      <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

      <div v-else class="animated fadeIn">

        <div class="ui grid">
          <div class="sixteen wide column">
            <div class="ui form">
              <div class="fields">
                <div class="two wide field">
                  <label class="form-label">Data Inicial</label>
                  {{ $formatDate(filter.startDate) }}
                </div>
                <div class="two wide field">
                  <label class="form-label">Data Final</label>
                  {{ $formatDate(filter.endDate) }}
                </div>
                <div class="three wide field">
                  <label class="form-label">Colaborador</label>
                  {{ filter.user.name ? filter.user.name.trim() + ' ' + filter.user.lastName : '' }}
                </div>
                <div class="three wide field">
                  <label class="form-label">Status</label>
                  <span v-html="filter.statusLabel"></span>
                </div>
                <div v-if="filter.paymentType" class="six wide field">
                  <label class="form-label">Tipo de Pagamento</label>
                  <span v-html="filter.paymentTypeLabel"></span>
                </div>
                <div v-if="filter.customerId" class="six wide field">
                  <label class="form-label">Clínica</label>
                  {{ filter.customerName }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <table v-if="filter.paymentType" class="ui celled selectable tablet stackable table">
          <thead v-if="$isDesktop">
            <tr>
              <th>Laudo</th>
              <th>Data</th>              
              <th>Clínica</th>
              <th>Animal</th>
              <th>Tutor</th>
              <th>Ficha</th>
              <th>Valor Serviço</th>
              <th>Valor Parcela</th>
              <th>Valor Recebido</th>
              <th></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(cert, index) in certs">
              <td>
                <strong class="mobile-only">Laudo: </strong>
                {{ cert.id }}
              </td>
              <td>
                <strong class="mobile-only">Data: </strong> {{ $formatDate(cert.date) }}
              </td>              
              <td>
                <strong class="mobile-only">Clínica: </strong> {{ cert.customerName }}
              </td>
              <td>
                <strong class="mobile-only">Animal: </strong>
                <i v-if="cert.animalSex == 'male'" class="mars blue icon"></i>
                <i v-if="cert.animalSex == 'female'" class="venus pink icon"></i>
                {{ cert.animalName }}                
              </td>
              <td>
                <strong class="mobile-only">Tutor: </strong> 
                {{ cert.ownerName }}                
              </td>
              <td>
                <strong class="mobile-only">Ficha: </strong> 
                {{ cert.registrationId }}                
              </td>
              <td>
                <strong class="mobile-only">Valor Serviço: </strong> R$ {{ $formatCurrency(cert.serviceValue) }}
              </td>
              <td>
                <strong class="mobile-only">Valor Parcela: </strong> R$ {{ $formatCurrency(cert.receivableValue) }}
              </td>
              <td>
                <strong class="mobile-only">Valor Recebido: </strong> R$ {{ $formatCurrency(cert.liquidReceivedValue) }}
              </td>                
              <td class="details-cell">
                <button class="ui small icon button" @click="onShowCert(cert.id)">
                  <i class="search plus icon"></i>
                </button>
              </td>
            </tr>                
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="bold text">R$ {{ $formatCurrency(totals.serviceValue) }}</td>
              <td class="bold text">R$ {{ $formatCurrency(totals.receivableValue) }}</td>
              <td class="bold text">R$ {{ $formatCurrency(totals.liquidReceivedValue) }}</td>
              <td></td>
            </tr>
          </tfoot>                         
        </table>

        <table v-if="filter.customerId" class="ui celled selectable tablet stackable table">
          <thead v-if="$isDesktop">
            <tr>
              <th>Laudo</th>
              <th>Data</th>
              <th>Animal</th>
              <th>Tutor</th>
              <th>Ficha</th>
              <th>Valor Serviço</th>
              <th>Valor Recebido</th>
              <th>Valor Colaborador</th>
              <th>Saldo Colaborador</th>
              <th></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(cert, index) in certs">
              <td>
                <strong class="mobile-only">Laudo: </strong> {{ cert.id }}
              </td>
              <td>
                <strong class="mobile-only">Data: </strong> {{ $formatDate(cert.date) }}
              </td>     
              <td>
                <strong class="mobile-only">Animal: </strong>
                <i v-if="cert.animalSex == 'male'" class="mars blue icon"></i>
                <i v-if="cert.animalSex == 'female'" class="venus pink icon"></i>
                {{ cert.animalName }}                
              </td>
              <td>
                <strong class="mobile-only">Tutor: </strong> 
                {{ cert.ownerName }}                
              </td>
              <td>
                <strong class="mobile-only">Ficha: </strong> 
                {{ cert.registrationId }}                
              </td>
              <td>
                <strong class="mobile-only">Valor Serviço: </strong> R$ {{ $formatCurrency(cert.serviceValue) }}
              </td>              
              <td>
                <strong class="mobile-only">Valor Recebido: </strong> R$ {{ $formatCurrency(cert.liquidReceivedValue) }}
              </td>    
              <td>
                <strong class="mobile-only">Valor Colaborador: </strong> R$ {{ $formatCurrency(cert.employeeValue) }}
              </td>            
              <td>
                <strong class="mobile-only">Saldo Colaborador: </strong> R$ {{ $formatCurrency(cert.payableValue) }}
              </td>            
              <td class="details-cell">
                <button class="ui small icon button" @click="onShowCert(cert.id)">
                  <i class="search plus icon"></i>
                </button>
              </td>
            </tr>                
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="bold text">R$ {{ $formatCurrency(totals.serviceValue) }}</td>
              <td class="bold text">R$ {{ $formatCurrency(totals.liquidReceivedValue) }}</td>
              <td class="bold text">R$ {{ $formatCurrency(totals.employeeValue) }}</td>              
              <td class="bold text">R$ {{ $formatCurrency(totals.payableValue) }}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>

        <table class="ui celled selectable tablet stackable table m-t-40">
          <thead v-if="$isDesktop">
            <tr>
              <th>Serviço</th>
              <th>Laudos</th>
              <th>Valor Total</th>
              <th>Total Recebido</th>
              <th v-if="filter.customerId">Total Colaborador</th>
              <th v-if="filter.customerId">Saldo Colaborador</th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(service, index) in resume.services">                            
              <td>
                <strong class="mobile-only">Serviço: </strong> 
                {{ service.description }}
                <span class="ui small label m-l-10">
                  <i :class="service.typeIcon"></i>
                  {{ service.typeDescription }}
                </span>
              </td>              
              <td>
                <strong class="mobile-only">Laudos: </strong> {{ $formatInteger(service.count) }}   
              </td>
              <td>
                <strong class="mobile-only">Valor Total: </strong> R$ {{ $formatCurrency(service.value) }}
              </td>
              <td>
                <strong class="mobile-only">Total Recebido: </strong> R$ {{ $formatCurrency(service.liquidReceivedValue) }}
              </td>
              <td v-if="filter.customerId">
                <strong class="mobile-only">Total Colaborador: </strong> R$ {{ $formatCurrency(service.employeeValue) }}
              </td>
              <td v-if="filter.customerId">
                <strong class="mobile-only">Saldo Colaborador: </strong> R$ {{ $formatCurrency(service.payableValue) }}
              </td>              
            </tr>                
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td class="bold text">{{ $formatInteger(resume.totals.count) }}</td>
              <td class="bold text">R$ {{ $formatCurrency(resume.totals.value) }}</td>
              <td class="bold text">R$ {{ $formatCurrency(resume.totals.liquidReceivedValue) }}</td>
              <td v-if="filter.customerId" class="bold text">R$ {{ $formatCurrency(resume.totals.employeeValue) }}</td>
              <td v-if="filter.customerId" class="bold text">R$ {{ $formatCurrency(resume.totals.payableValue) }}</td>
            </tr>
          </tfoot>
        </table>

      </div>

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Sair
      </button>
    </div>

  </div>

</template>

<script>

  import _ from "underscore"
  import EmployeeInvoiceService from "@/services/employee-invoice-service"
  import FinancialService from "@/services/financial-service"
  import CertService from "@/services/cert-service"
  import SrvService from "@/services/srv-service"
  import modalDialog from "@/mixins/modal-dialog"
  import AppBrowser from "@/utils/browser"

  export default {
    
    name: "EmployeeCertsModal",

    mixins: [modalDialog],

    data() {
      return {
        certs: [],
        totals: {},
        resume: { services: [], totals: {} },
        filter: { user: {}, customer: {} },
        service: new EmployeeInvoiceService(),
      }
    },

    methods: {

      load(filter) {                
        this.filter = filter
        this.setStatusLabel()
        this.setPaymentTypeLabel()
        this.loadCerts()
        this.show()
      },

      setStatusLabel() {

        let label = ""
        const status = this.filter.status || "*"
        const statusList = EmployeeInvoiceService.getFilterStatusList()

        for (const el of statusList) {
          if (el.id == status)
            label = el.value
        }

        this.filter.statusLabel = label
      },

      setPaymentTypeLabel() {

        if (this.filter.paymentType)
          this.filter.paymentTypeLabel = FinancialService.PAYMENT_TYPE[this.filter.paymentType].label  
      },

      async loadCerts() {

        this.loading = true

        try {

          this.certs = await this.service.getEmployeeCerts(this.filter)

          this.loadCertsData()
          this.loadResume()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      loadCertsData() {

        this.totals = {
          serviceValue: 0,
          receivableValue: 0,
          liquidReceivedValue: 0,
          employeeValue: 0,
          payableValue: 0,
        }

        this.certs.forEach((cert) => {

          cert.statusData = CertService.STATUS[cert.status]
          cert.financialStatusData = CertService.FINANCIAL_STATUS[cert.financialStatus]
          cert.serviceTypeData = SrvService.TYPE_ICONS[cert.serviceTypeIcon]

          this.totals.serviceValue += cert.serviceValue
          this.totals.liquidReceivedValue += cert.liquidReceivedValue        
          this.totals.receivableValue += cert.receivableValue || 0
          this.totals.employeeValue += cert.employeeValue || 0
          this.totals.payableValue += cert.payableValue || 0
        })
      },

      loadResume() {

        let service = null
        let services = []        
        let totals = { 
          count: 0, 
          value: 0, 
          liquidReceivedValue: 0, 
          employeeValue: 0,
          payableValue: 0,
        }

        for (const cert of this.certs) {

          service = services.find((srv) => srv.id == cert.serviceId && srv.typeId == cert.serviceTypeId)

          if (service) {
            
            service.count++
            service.value += cert.serviceValue            
            service.liquidReceivedValue += cert.liquidReceivedValue
            service.employeeValue += cert.employeeValue || 0
            service.payableValue += cert.payableValue || 0            

          } else {

            services.push({
              count: 1,              
              id: cert.serviceId,
              typeId: cert.serviceTypeId,
              description: cert.serviceDescription,
              typeDescription: cert.serviceTypeDescription,
              typeIcon: cert.serviceTypeData.icon,
              value: cert.serviceValue,              
              liquidReceivedValue: cert.liquidReceivedValue,
              employeeValue: cert.employeeValue || 0,
              payableValue: cert.payableValue || 0,
              sortKey: cert.serviceDescription.trim().toLowerCase() + cert.serviceTypeDescription.trim().toLowerCase(),
            })
          }

          totals.count++
          totals.value += cert.serviceValue          
          totals.liquidReceivedValue += cert.liquidReceivedValue
          totals.employeeValue += cert.employeeValue
          totals.payableValue += cert.payableValue
        }

        this.resume.services = _.sortBy(services, "sortKey")
        this.resume.totals = totals
      },

      onShowCert(id) {
        AppBrowser.openNewTab(`/procs/certs/${id}/show`)
      },
    },
  }

</script>